import {
  prepareRequest
} from './request'

export const orderBet = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    url: 'ordering/bet:order',
    method: 'POST',
    query,
    signal
  })
  return request(body)
}

export const cancelOrderBet = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    url: 'ordering/bet:cancel',
    method: 'POST',
    query,
    signal
  })
  return request(body)
}

export const findActiveOrderBets = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    url: 'ordering/bet/active:search',
    method: 'POST',
    query,
    signal
  })
  return request(body)
}

export const findCompletedOrderBets = ({ body, query, signal = null }) => {
  const request = prepareRequest({
    url: 'ordering/bet/completed:search',
    method: 'POST',
    query,
    signal
  })
  return request(body)
}
